import JOB_ACTION_CARD_CONSTANT from '../constants/jobconstants';
import JOB_CARD_ACTION from './index.action';

const { DEFAULT, PASSEDTEST_NOTBOOKTI, BOOKEDTI_FUTUREDATE, BOOKEDTI_PASSED, CONSIDERED, ANOTHER_PICKED, BOOKEDTI_FAILED, SELF_PICKED } = JOB_ACTION_CARD_CONSTANT;
const initialState = {
  mcqId: null,
  jobId: null,
  job: null,
  bookTi: false,
  jobStatuses: [DEFAULT, PASSEDTEST_NOTBOOKTI, BOOKEDTI_FUTUREDATE, BOOKEDTI_PASSED, CONSIDERED, ANOTHER_PICKED, BOOKEDTI_FAILED, SELF_PICKED]
};

function JobCardReducer (state = initialState, action) {
  const { type = '', payload = null } = { ...action };
  switch (type) {
    case JOB_CARD_ACTION.JOB_BOOK_TI:
    case JOB_CARD_ACTION.JOB_CONSIDER_ME:
    case JOB_CARD_ACTION.JOB_READ_MORE:
    case JOB_CARD_ACTION.JOB_START_TEST: {
      return { ...state, ...payload };
    }

    default:
      return { ...state };
  }
}

export default JobCardReducer;
